import { render, staticRenderFns } from "./AssignAuth.vue?vue&type=template&id=622c1c84&scoped=true&"
import script from "./AssignAuth.vue?vue&type=script&lang=js&"
export * from "./AssignAuth.vue?vue&type=script&lang=js&"
import style0 from "./AssignAuth.vue?vue&type=style&index=0&id=622c1c84&lang=less&scoped=true&"
import style1 from "./AssignAuth.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c1c84",
  null
  
)

export default component.exports